import { render, staticRenderFns } from "./GroupedSearchResults.vue?vue&type=template&id=6436236b&"
import script from "./GroupedSearchResults.vue?vue&type=script&lang=js&"
export * from "./GroupedSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./GroupedSearchResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports